import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import Ellipsis, { extractEllipsisProps } from '../common/Ellipsis';
import style from './Heading.st.css';
export var APPEARANCES = {
  H1: 'H1',
  H2: 'H2',
  H3: 'H3',
  H4: 'H4',
  H5: 'H5',
  H6: 'H6'
};

var Heading = function Heading(props) {
  var _extractEllipsisProps = extractEllipsisProps(props),
      ellipsisProps = _extractEllipsisProps.ellipsisProps,
      componentProps = _extractEllipsisProps.componentProps;

  var light = componentProps.light,
      appearance = componentProps.appearance,
      children = componentProps.children,
      dataHook = componentProps.dataHook,
      headingProps = _objectWithoutProperties(componentProps, ["light", "appearance", "children", "dataHook"]);

  return /*#__PURE__*/React.createElement(Ellipsis, _extends({}, ellipsisProps, {
    // TODO - with Stylable3 change to wrapperClassName
    wrapperClasses: style('root', {
      appearance: appearance
    }),
    render: function render(_ref) {
      var ref = _ref.ref,
          ellipsisClasses = _ref.ellipsisClasses;
      return /*#__PURE__*/React.createElement(appearance.toLowerCase(), _objectSpread(_objectSpread(_objectSpread({}, headingProps), {}, {
        ref: ref,
        'data-hook': dataHook
      }, style('root', {
        light: light,
        appearance: appearance
      }, {
        className: ellipsisClasses(props.className)
      })), {}, {
        'data-appearance': appearance,
        'data-light': light
      }), children);
    }
  }));
};

Heading.displayName = 'Heading';
Heading.propTypes = _objectSpread({
  dataHook: PropTypes.string,

  /** any nodes to be rendered (usually text nodes) */
  children: PropTypes.any,

  /** is the text has dark or light skin */
  light: PropTypes.bool,

  /** typography of the heading */
  appearance: PropTypes.oneOf(Object.keys(APPEARANCES))
}, Ellipsis.propTypes);
Heading.defaultProps = _objectSpread({
  appearance: APPEARANCES.H1,
  light: false
}, Ellipsis.defaultProps);
export default Heading;